import { useMemo } from 'react';
import { analyzeCode } from '../../lib/analyze';

const SEC = { init: 'text-violet-300 border-violet-500/40', update: 'text-cyan-300 border-cyan-500/40', render: 'text-fuchsia-300 border-fuchsia-500/40', controls: 'text-amber-300 border-amber-500/40' };

function Chips({ items, cls }) {
  if (!items.length) return <span className="text-[10px] text-slate-600">—</span>;
  return <div className="flex flex-wrap gap-1">{items.slice(0, 24).map((x) => <span key={x} className={`rounded border px-1.5 py-0.5 text-[10px] ${cls}`}>{x}</span>)}</div>;
}

export default function StructurePanel({ game }) {
  const a = useMemo(() => analyzeCode(game.code), [game.code]);
  const stat = [['Renderer', a.renderer], ['Righe', a.lines], ['Peso', `${(a.bytes / 1024).toFixed(1)} KB`], ['Controller', a.controls.toUpperCase()]];
  return (
    <div data-testid="structure-panel" className="space-y-5">
      <div className="t-label">Reverse Engineering</div>
      <div className="grid grid-cols-2 gap-2">
        {stat.map(([k, v]) => <div key={k} className="rounded-lg border border-white/10 p-2.5"><div className="t-label">{k}</div><div className="text-sm font-bold text-slate-100 mt-0.5">{v}</div></div>)}
      </div>
      <div className="flex gap-2 text-[10px]">
        <span className={`rounded-full px-2 py-0.5 border ${a.titan ? 'border-emerald-500/50 text-emerald-300' : 'border-slate-700 text-slate-500'}`}>TITAN contract {a.titan ? '✓' : '✗'}</span>
        <span className={`rounded-full px-2 py-0.5 border ${a.audio ? 'border-emerald-500/50 text-emerald-300' : 'border-slate-700 text-slate-500'}`}>Audio {a.audio ? '✓' : '✗'}</span>
      </div>
      {Object.entries(a.sections).map(([k, v]) => (
        <div key={k}><div className="t-label mb-1.5">{k}</div><Chips items={v} cls={SEC[k]} /></div>
      ))}
      <div><div className="t-label mb-1.5">Classi</div><Chips items={a.classes} cls="text-slate-200 border-white/15" /></div>
      <div><div className="t-label mb-1.5">Event listeners</div><Chips items={a.listeners} cls="text-slate-300 border-white/15" /></div>
    </div>
  );
}
